module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA1.w.1.1.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.18.1.0.box.538.1044.567.141.q.100"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA1.w.1.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_heading",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "id": "para.18.1.0.box.750.1044.135.38.q.100"
    }
  }, [_vm._v("Part I")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA1.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_heading",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "id": "para.18.1.1.box.538.1142.567.43.q.90"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA2"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA2.w.0.0.0"
    }
  }), _vm._v("PLANTATION PEOPLE")])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA3"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA3.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA3.w.1.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA3.w.1.0.0.1"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA3.w.1.0.0.2"
    }
  })]), _c('div', {
    staticClass: "flow"
  }), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('div', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA3"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gimg_graphic",
    attrs: {
      "id": "block.20.0.0.box.330.336.1076.684.q.101"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA3.w.1.0.0.3"
    }
  }), _c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%"
    },
    attrs: {
      "alt": "[graphic]",
      "src": "data/content-0009.png"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA3.w.1.0.0.4"
    }
  })])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA3.w.1.0.0.5"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-93eebb00","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/content/content0010.vue
// module id = 60
// module chunks = 0